import { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { buildApiUrl } from '../config/api';

/**
 * Hook para validar acesso via UUID e token, buscando dados do QR code no backend.
 * Retorna: { loading, error, participantId, envelopeId, tokenValid }
 */
export function useQrCodeAccess(page = '') {
  const { uuid } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [participantId, setParticipantId] = useState(null);
  const [envelopeId, setEnvelopeId] = useState(null);
  const [tokenValid, setTokenValid] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError('');
    setTokenValid(null);
    const pageQuery = page ? `&page=${page}` : '';
    fetch(buildApiUrl(`qrcode/${uuid}?token=${token}${pageQuery}`))
      .then(resp => {
        if (!resp.ok) throw new Error('QR code ou token inválido ou expirado.');
        return resp.json();
      })
      .then(data => {
        setParticipantId(data.participant_id);
        setEnvelopeId(data.envelope_id);
        setTokenValid(true);
        localStorage.setItem(`qrcode_${uuid}`,
          JSON.stringify({ participant_id: data.participant_id, envelope_id: data.envelope_id })
        );
      })
      .catch(() => {
        setError('QR code ou token inválido ou expirado.');
        setTokenValid(false);
      })
      .finally(() => setLoading(false));
  }, [uuid, token, page]);

  return { loading, error, participantId, envelopeId, tokenValid, token, uuid };
}
